<div class="row" *ngIf="showHeader">
  <div class="col-sm-1"></div>
  <div class="col-sm-10">
    <h1 style="font-family: Roboto, Helvetica Neue, sans-serif; font-size: 40px; font-weight: bold; color: black; margin-left: -15px;">Widgets</h1>
  </div>
  <div class="col-sm-1"></div>
</div>
<div class="row">
  <div class="col-sm-1"></div>
  <div class="col-sm-3 mainLabel">Widget Type</div>
  <div class="col-sm-3 mainLabel">Widget</div>
  <div class="col-sm-3 mainLabel">Actions</div>
  <div class="col-sm-1 mainLabel"></div>
  <div class="col-sm-1"></div>
</div>
<div class="row">
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-1"></div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-3">
    <mat-form-field style="width: 100%">
      <mat-select [(ngModel)]="currentSelectedWidget"
                  id="currentSelectedWidget"
                  name="currentSelectedWidget"
                  class="modifiedDropDown"
                  (selectionChange)="selectWidgetType()">
        <mat-option *ngFor="let widgetType of userState?.reportExportState?.reportEmbeddedTypes" [value]="widgetType">{{ widgetType.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-3">
    <mat-form-field style="width: 100%">
      <mat-select id="currentSelectedWidgetLayout"
                  class="currentSelectedWidgetLayout"
                  [(ngModel)]="currentSelectedWidgetLayout"
                  (selectionChange)="selectWidgetLayout()">
        <mat-option *ngFor="let layout of filteredWidgetLayouts" [value]="layout">{{ layout.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-3">
    <mat-form-field style="width: 100%">
      <mat-select id="currentSelectedAction" [(ngModel)]="currentSelectedAction">
        <mat-option value="Launch">Launch Widget</mat-option>
        <mat-option *ngIf="currentSelectedWidgetLayout && !currentSelectedWidgetLayout.gatedOnly" value="LaunchUnGated">Launch Un-Gated Widget</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-1">
    <button mat-raised-button class="piButton" style="margin-top: 10px; margin-left: 8px" (click)="goClick()">GO</button>
  </div>
</div>
